import { State as ListState, reducer as listReducer } from "features/course/reducers/list";
import { State as EditState, reducer as editReducer } from "features/course/reducers/edit";
import { combineReducers } from "redux";

export interface State {
    courses: {
        list: ListState;
        edit: EditState;
    };
}

export const reducer = combineReducers({
    list: listReducer,
    edit: editReducer,
});
